import React from "react";

export default function InspectionPolicy({ name }) {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        CMV Inspection Policy Acknowledgement
      </h4>
      <p>
        I {name ? <b>{name}</b> : ""} acknowledge that I have been trained on
        the proper procedures to conduct a Pre-Trip Inspection, Post-Trip
        Inspection, Couple, Uncouple and 5th wheel tug test of a Commercial
        Motor Vehicle.
      </p>
      <p>
        I further agree that I shall each day conduct a full Pre-Trip and
        Post-Trip Inspection of every Commercial Motor Vehicle which I drive in
        accordance with Regulation199/07 of the Highway Traffic Act and FMCSA
        reg.392.7. And that I will record the inspections correctly in a vehicle
        inspection booklet. As well that each time, I couple to a trailer I will
        ensure the 5th wheel is properly connected by performing a visual and
        tug test inspection.
      </p>
      <p>
        I will report to dispatch any and all defects which I discover during
        any vehicle inspection immediately.
      </p>
      <p>
        I understand that failure to follow this policy or regulations will
        result in disciplinary action which may include termination.
      </p>
    </div>
  );
}
